import React from 'react';
import './style.css';
import './SBSBadge.css';
import SBSBadge from './components/SBSBadge';
import logo from './selenne-logo.png';

const services = [
  {
    title: 'Business Structuring',
    items: ['LLC, Corp, and Nonprofit Filings', 'State and Federal Registrations', 'Operating Agreements', 'EIN and Compliance Setup'],
  },
  {
    title: 'Brand Development',
    items: ['Logo and Identity Creation', 'Market Positioning Strategy', 'Website Creation', 'Launch Roadmaps'],
  },
  {
    title: 'Cigar Brand Consulting',
    items: ['Vendor and Supplier Guidance', 'Packaging Design Strategy', 'Retail and Online Launch Plans', 'Industry Compliance Support'],
  },
  {
    title: 'Client Systems',
    items: ['Process and SOP Mapping', 'CRM and Intake Flows', 'Onboarding Templates', 'System Design Audits'],
  },
  {
    title: 'Financial Command Centers',
    items: ['Payroll and Transaction Tools', 'Real-Time Reporting via SBS', 'Monthly Revenue Tracking', 'Client Dashboard Portals'],
  },
];

function Home() {
  return (
    <div className="site-shell">
      <header className="corporate-header">
        <div className="brand-block">
          <SBSBadge />
          <img src={logo} alt="Selenne Strategies Logo" className="brand-logo" />
          <div>
            <p className="eyebrow">Business strategy and operating infrastructure</p>
            <h1>Selenne Strategies</h1>
          </div>
        </div>

        <nav className="main-nav" aria-label="Primary navigation">
          <a href="#services">Services</a>
          <a href="#about">Philosophy</a>
          <a href="/dominicana">Dominicana</a>
          <a href="#contact">Contact</a>
          <a href="https://dashboard.selenne.io/pricing" target="_blank" rel="noopener noreferrer">Pricing</a>
          <a href="https://dashboard.selenne.io" className="nav-button" target="_blank" rel="noopener noreferrer">Client Login</a>
        </nav>
      </header>

      <main>
        <section className="hero-section">
          <div className="hero-copy">
            <p className="section-kicker">Dream. Design. Build. Succeed.</p>
            <h2>Business growth starts with strategy.</h2>
            <p>
              At Selenne Strategies, we help turn vision into reality. We meet you where you are, whether you are in the idea phase,
              structuring your enterprise, or streamlining your back office. We provide the clarity, tools, and operating structure
              to build with confidence.
            </p>
            <div className="hero-actions">
              <a href="/onboarding" className="primary-button">Apply for Consulting</a>
              <a href="#services" className="secondary-button">Explore Services</a>
            </div>
          </div>

          <aside className="hero-panel" aria-label="Selenne Strategies focus areas">
            <span className="panel-label">Strategic Focus</span>
            <h3>Clarity. Structure. Execution.</h3>
            <p>
              We support founders and operators with business formation, brand direction, systems design, and financial visibility.
            </p>
            <div className="metric-grid">
              <div>
                <strong>01</strong>
                <span>Structure</span>
              </div>
              <div>
                <strong>02</strong>
                <span>Systems</span>
              </div>
              <div>
                <strong>03</strong>
                <span>Scale</span>
              </div>
            </div>
          </aside>
        </section>

        <section id="services" className="content-section services-section">
          <div className="section-heading">
            <p className="section-kicker">What we do</p>
            <h3>Our Services</h3>
            <p>
              Practical business development support for entrepreneurs, established companies, and brands preparing for their next stage.
            </p>
          </div>

          <div className="service-grid">
            {services.map((service) => (
              <article className="service-card" key={service.title}>
                <h4>{service.title}</h4>
                <ul>
                  {service.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </section>

        <section id="about" className="split-section">
          <div>
            <p className="section-kicker">Our philosophy</p>
            <h3>Clarity is the currency of leadership.</h3>
          </div>
          <div className="split-copy">
            <p>
              At Selenne Strategies, we guide visionary founders through the complexity of business-building with elegance,
              efficiency, and intention. Our approach combines elevated presentation with structured systems, empowering clients
              to create sustainable brands rooted in purpose.
            </p>
            <p>
              Whether you are designing your legacy or simplifying your operations, we help you build infrastructure, not just income.
            </p>
          </div>
        </section>

        <section className="dominicana-preview">
          <div>
            <p className="section-kicker">Sister company</p>
            <h3>Selenne Strategies Succursal Dominicana</h3>
            <p>
              A dedicated page for the Dominican company, connecting local and international business development under the same Selenne Strategies brand family.
            </p>
          </div>
          <a href="/dominicana" className="secondary-button light">Visit Dominicana Page</a>
        </section>

        <section id="contact" className="contact-section">
          <p className="section-kicker">Let's connect</p>
          <h3>Ready to move forward with clarity?</h3>
          <p>We are here to answer questions, book consultations, and help you move forward.</p>
          <a href="mailto:info@selennestrategies.com" className="email-link">info@selennestrategies.com</a>
        </section>
      </main>

      <footer className="site-footer">
        <p>© {new Date().getFullYear()} Selenne Strategies. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Home;
